import { render, staticRenderFns } from "./Minderspanne.vue?vue&type=template&id=3b536eee&"
import script from "./Minderspanne.vue?vue&type=script&lang=js&"
export * from "./Minderspanne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports